"use client";

import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { translations, currentLang } = useLanguage();
  const t = translations[currentLang];
  return (
    <footer className="bg-black text-center p-10 border-t border-gray-800">
      <div className="mb-5">
        <a
          href="#"
          className="text-white no-underline text-sm hover:text-blue-400 transition-colors duration-300"
        >
          {t.privacy}
        </a>
      </div>

      {/* <div className="my-5 flex justify-center gap-6">
        <a
          href="#"
          className="text-white text-sm no-underline hover:text-blue-400 transition-colors duration-300"
        >
          Blog
        </a>
        <a
          href="#"
          className="text-white text-sm no-underline hover:text-blue-400 transition-colors duration-300"
        >
          Facebook
        </a>
        <a
          href="#"
          className="text-white text-sm no-underline hover:text-blue-400 transition-colors duration-300"
        >
          Instagram
        </a>
        <a
          href="#"
          className="text-white text-sm no-underline hover:text-blue-400 transition-colors duration-300"
        >
          LinkedIn
        </a>
      </div> */}

      <p className="text-xs text-gray-500 mt-5">{t.footer}</p>
    </footer>
  );
};

export default Footer;
